export const environment = {
  production: true,
  webserviceUrl: 'https://api1.app.podopro.eu',
  cadWebserviceUrl: 'https://cam.insole.podopro.eu',
  frontend: 'https://v3.app.podopro.eu',
  lunaUrl: 'https://luna.app.podopro.eu/#',
  fullstackAssistantWebserviceUrl: 'http://localhost:8085',
  oldFrontendApplication: 'http://app.maxsoft.be/podopro-web',
  oldWebserviceUrl: 'https://app.maxsoft.be/podopro-web/webservices',
  webservicesTimeOut: 100000,
  version: '23/06/2026 11h00',
  domain: 'prod',
  recaptcha: {
    siteKey: '6LeDsrMnAAAAANDQKhvzPtXKuY4h7l0XznfkOK-G',
  },
  googleTagManagerId: 'GTM-KG679DN',
  stripeUrl: 'https://dashboard.stripe.com'
};
